import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ButtonIconSet, ButtonIconType } from '../buttons.types';

@Component({
  selector: 'common-buttons-outlined',
  templateUrl: './buttons-outlined.component.html',
  styleUrls: ['./buttons-outlined.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonsOutlinedComponent implements OnInit {
  private readonly defaultIconSet = 'material-symbols-rounded';

  @Input() label: string;
  @Input() icon: string;
  @Input() disabled: boolean = false;
  /**
   * `ds`: usa el ancho del Design System (definido en SCSS).
   * `fill`: ocupa el 100% del contenedor.
   */
  /** `hug`: ancho según contenido (sin 328px del DS). */
  @Input() widthLayout: 'ds' | 'fill' | 'hug' = 'ds';
  /** Ancho fijo CSS (ej. `135px`). Tiene prioridad sobre `ds` pero no sobre `fill`. */
  @Input() width?: string;
  @Input() typeIcon: ButtonIconType
  @Input() iconSet: ButtonIconSet;
  @Input() iconPosition: boolean = true;

  @Output() output: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor() { }

  ngOnInit(): void { }

  get resolvedWidth(): string | null {
    if (this.widthLayout === 'fill') return '100%';
    if (this.widthLayout === 'hug') return 'fit-content';
    const w = String(this.width ?? '').trim();
    return w ? w : null;
  }

  get iconClass(): string {
    if (this.iconSet) {
      return this.iconSet;
    }

    if (this.typeIcon === 'outlined') {
      return 'material-icons-outlined';
    }

    if (this.typeIcon === 'rounde') {
      return 'material-symbols-rounded';
    }

    return this.defaultIconSet;
  }

  onClick() {
    this.output.emit(true);
  }
}
